import { PHeading } from '@porsche-design-system/components-react';
import { type FC } from 'react';

type Props = {
    children: React.ReactNode;
};

const Title: FC<Props> = ({ children }) => <PHeading size="x-large">{children}</PHeading>;

export default Title;
